import React from 'react';
import { Alert, Table }  from 'reactstrap';
import * as Icon from 'react-feather';
import { ConfirmModal } from '../Modals/Confirm';

export function ConfirmDeletePrintingNcrModal(props) {
    return (
        <ConfirmModal 
            isOpen={props.isOpen}
            toggle={props.toggle} 
            handleConfirm={(e) => props.handleConfirm(props.printingNcr, e)}
            title={"Delete Non-Conformance Report"}
            confirmText="Yes, Delete Non-Conformance Report"
            confirmColor="danger"
            confirmIcon={Icon.Trash2}
        >
            <Alert color="warning">
                <strong>Are you sure you wish to delete the following Non-Conformance Report?</strong>
            </Alert>

            <Table bordered>
                <thead>
                    <tr>
                        <th className="col-xs-4">NCR Log No</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{props.printingNcr.ncrLogNo}</td>
                    </tr>
                </tbody>
            </Table>
        </ConfirmModal>
    );
}